//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SlipDel from 'vue-slip-delete'
// import demo2 from './demo2'
export default {
  components: {
    SlipDel,
    // abc:demo2
  },
  data(){
      return{
        list:[1,2,3,4,5],
        data:'10004'
      }
    },
  methods: {
    slipOpen(vm) {
      // 无需手动关闭
    },
    del(i) {
      // 删除回调
      console.log('hahaha')
      console.log(i)
      this.list.splice(i,1)
      
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/demo.vue